import type { PosCartItem } from '../../domain/models/PosCartItem';
import type { PosCartItemDTO } from '../dto/posCart.dto';

export function posCartItemDtoToDomain(dto: PosCartItemDTO): PosCartItem {
  return {
    designId: dto.designId,
    designName: dto.designName,
    designCode: dto.designCode,
    skuCode: dto.skuCode,
    categoryType: dto.categoryType,
    imageUrl: dto.imageUrl,
    productPageUrl: dto.productPageUrl,
    price: dto.price,
    discountedPrice: dto.discountedPrice,
    discountName: dto.discountName,
    isAddedToCart: dto.isAddedToCart,
    sourceType: dto.sourceType,
    discountPercent: dto.discountPercent,
    discountOnDiamondPriceValue: dto.discountOnDiamondPriceValue,
    discountValue: dto.discountValue,
    customizationId: dto.customizationId,
    metal: dto.metal,
    defaultSize: dto.defaultSize,
    customizationOptions: dto.customizationOptions,
    mediaItems: dto.mediaItems,
  };
}

export function posCartItemDomainToPlain(item: PosCartItem): Record<string, unknown> {
  return {
    designId: item.designId,
    designName: item.designName,
    designCode: item.designCode,
    skuCode: item.skuCode,
    categoryType: item.categoryType,
    imageUrl: item.imageUrl,
    productPageUrl: item.productPageUrl,
    price: item.price,
    discountedPrice: item.discountedPrice,
    discountName: item.discountName,
    isAddedToCart: item.isAddedToCart,
    sourceType: item.sourceType,
    ...(item.discountPercent != null ? { discountPercent: item.discountPercent } : {}),
    ...(item.discountOnDiamondPriceValue != null ? { discountOnDiamondPriceValue: item.discountOnDiamondPriceValue } : {}),
    ...(item.discountValue != null ? { discountValue: item.discountValue } : {}),
    ...(item.customizationId != null ? { customizationId: item.customizationId } : {}),
    ...(item.metal != null ? { metal: item.metal } : {}),
    ...(item.defaultSize != null ? { defaultSize: item.defaultSize } : {}),
    ...(item.customizationOptions != null ? { customizationOptions: item.customizationOptions } : {}),
    ...(item.mediaItems != null ? { mediaItems: item.mediaItems } : {}),
  };
}

export function posCartItemPlainToDomain(plain: Record<string, unknown>): PosCartItem {
  return {
    designId: Number(plain.designId),
    designName: String(plain.designName),
    designCode: String(plain.designCode),
    skuCode: String(plain.skuCode),
    categoryType: String(plain.categoryType),
    imageUrl: String(plain.imageUrl),
    productPageUrl: String(plain.productPageUrl),
    price: String(plain.price),
    discountedPrice: plain.discountedPrice ? String(plain.discountedPrice) : undefined,
    discountName: plain.discountName ? String(plain.discountName) : undefined,
    isAddedToCart: Boolean(plain.isAddedToCart),
    sourceType: plain.sourceType as PosCartItem['sourceType'],
    // Extended properties
    discountPercent: plain.discountPercent != null ? Number(plain.discountPercent) : undefined,
    discountOnDiamondPriceValue: plain.discountOnDiamondPriceValue != null ? Number(plain.discountOnDiamondPriceValue) : undefined,
    discountValue: plain.discountValue ? String(plain.discountValue) : undefined,
    customizationId: plain.customizationId != null ? Number(plain.customizationId) : undefined,
    metal: plain.metal ? String(plain.metal) : undefined,
    defaultSize: plain.defaultSize ? String(plain.defaultSize) : undefined,
    customizationOptions: plain.customizationOptions as PosCartItem['customizationOptions'],
    mediaItems: plain.mediaItems as PosCartItem['mediaItems'],
  };
}
